import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { DisplayMode } from '../../../sessionManagement/serverApi/types/ISessionInfo';

export interface IUpdateDisplayModeParams {
  displayMode: DisplayMode;
}

export class UpdateDisplayModeRequest extends Request<IUpdateDisplayModeParams, IResult> {
  constructor(params: IUpdateDisplayModeParams) {
    super('updateDisplayMode', params);
  }
}
